"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableActions = getAvailableActions;
const core_1 = require("@pentacode/core");
function getAvailableActions(timeEntry, settings) {
    const startString = timeEntry.startFinal || timeEntry.startPlanned || new Date();
    const startTime = new Date(startString).getTime();
    const canStart = startTime - settings.allowEarlyStart * core_1.hour < Date.now();
    const isUnlocked = Date.now() < startTime + settings.lockAfter * core_1.hour;
    const shiftReady = canStart && isUnlocked;
    // Can't do anything if shift is not ready
    if (!shiftReady)
        return [];
    if (!timeEntry.startPlanned && !timeEntry.startFinal) {
        if ((0, core_1.getToday)() !== timeEntry.date) {
            //shifts with flexible start (open-open, open-XX:YY) have to be started on the same day
            return [];
        }
    }
    // If paused, can end the break or the shift
    if (timeEntry.status === "paused") {
        return ["endBreak", "endShift"];
    }
    // If ongoing, can end the shift or start a break if allowed
    if (timeEntry.status === "ongoing") {
        if (settings.manualBreaksAllowed) {
            return ["startBreak", "endShift"];
        }
        return ["endShift"];
    }
    // If scheduled, can start the shift
    if (timeEntry.status === "scheduled") {
        return ["startShift"];
    }
    // Default (e.g completed), can't do anything
    return [];
}
//# sourceMappingURL=available-actions.js.map